import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./components/HomePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "./i18n/LanguageContext";

// The homepage is a full-bleed, self-contained experience (its own header and
// footer), so it renders outside the shared chrome. Only subpages use Layout.
function App() {
  return (
    <LanguageProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route element={<Layout />}>
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Route>
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
